import React from 'react';
import { Layout } from 'antd';
import { TreeView } from '../components/library/tree-view';
import BannerGrid from '../components/library/banner-viewer';
import { useResponsiveSizes } from '../hooks/use-responsive-sizes';
import { PageTitle } from '../components/ui/layout/page-title';
import { PageContainer } from 'src/components/ui/layout/page-container';

const { Sider, Content } = Layout;

const LibraryContent: React.FC = () => {
  const { screens } = useResponsiveSizes();

  return (
    <Layout style={{ display: 'flex', gap: screens.md ? '24px' : 0 }}>
      {/* Sidebar solo en desktop */}
      {screens.md && (
        <Sider width={350} theme='light'>
          <TreeView />
        </Sider>
      )}
      <Content>
        <BannerGrid />
      </Content>
    </Layout>
  );
};

export const LibraryPage: React.FC = () => {
  const { spacing } = useResponsiveSizes();

  return (
    <PageContainer>
      <PageTitle style={{ marginBottom: spacing.md }}>Librería</PageTitle>
      <LibraryContent />
    </PageContainer>
  );
};
